/**
 * Centralized animation timing constants.
 *
 * Use these instead of hardcoded durations so motion feels consistent
 * across the app.  Values are in seconds (for motion/react) — multiply
 * by 1000 when a millisecond value is needed (e.g. setTimeout).
 */

/** Fast micro-interactions: tooltips, button feedback */
export const DURATION_FAST = 0.15;

/** Standard transitions: modals, dropdowns, accordions */
export const DURATION_NORMAL = 0.25;

/** Deliberate entrance/exit: list items, panels, toasts */
export const DURATION_SLOW = 0.6;

/** Long-running emphasis: highlight fades, surface enter/exit */
export const DURATION_EMPHASIS = 0.7;

/** Default easing curve */
export const EASE_DEFAULT: [number, number, number, number] = [0.25, 0.1, 0.25, 1.0]; // ease

/** Easing for elements entering the viewport */
export const EASE_OUT: [number, number, number, number] = [0, 0, 0.2, 1.0];
